// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CancelScheduledTransactionsDialogController = function ($scope, $modalInstance) {
    $scope.model = { resultValue: true };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        $modalInstance.close($scope.model.resultValue);
    };
};

CancelScheduledTransactionsDialogController.$inject = ['$scope', '$uibModalInstance'];
